import { HexInfo } from "../LevelGeneration/LevelGenTypes";

export const handleHexClick = (hexInfo: HexInfo) => {
    if (hexInfo.HexAssets == "city"){
        
    }
};
